<ng-container *ngFor="let item of _listItems; let i=index">
    <div *ngIf='form && form.controls[item.id]' class="container" [formGroup]="form.controls[item.id]" [ngClass]="{
        'light-container': getlight(item)
        }">
        <!--form.controls[item.id].controls['value'].value > 0-->
        <div class="fs-7 bold opacity" [ngClass]="{'hasValue': form.controls[item.id].controls['value'].value > 0}">
            {{_listItems[i].descripcion}}
        </div>
        <div class='containerPrice'>
            <div class="opacity containerPrice__value " [ngClass]="{'hasValue': form.controls[item.id].controls['value'].value > 0}">
                  
                    <!--<input inputmode="numeric" pattern="[0-9]*" currencyFormatter [defaultValue]="true"
                        class="fs-6 bold hasValue" placeholder="0" formControlName="value" maxlength="6" />-->
                    
                            <input  commaSeparator   inputmode='decimal' [defaultValue]="true"
                            class="fs-6 bold hasValue" placeholder="0" formControlName="value"  maxlength="8" >               
    
            </div>
            <div class=" opacity containerPrice__currency"> € </div>
        </div>
    </div>
    <div>
        <ng-container *ngFor="let validation of validationsList;let i=index">
            <mat-error
                *ngIf="form && form.controls[item.id].controls['value'].hasError(validation.name) && form.controls[item.id].controls['id'].value == validation.id && form.controls[item.id].controls['value'].value > 0">
                {{validation.message}}</mat-error>
        </ng-container>

    </div>
</ng-container>